import React, { useEffect, createContext, useContext, useReducer } from "react";
import businessReducer from "../Reducers/business";
import getBusinessTeamMembers from "../actions/getBusinessTeamMembers";
import { useParams } from "react-router-dom";
import selectBusinessReducer from "../Reducers/selectBusinessReducer";
import getStaffServices from "../actions/getStaffServices";
import getOpeningHours from "../actions/getOpeningHours";

const businessContext = createContext();

export default function BusinessContextProvider({ children }) {
  const [businessData, setBusinessData] = useReducer(businessReducer, { loading: true });
  const [selectedBusiness, setSelectedBusiness] = useReducer(
    selectBusinessReducer,
    {
      unavailableDates: [],
      discount: null,
      categories: [],
      services: [],
      userDetails: {
        create_account: false,
      },
    }
  );
  const { businessID } = useParams();
  const groupService = selectedBusiness?.services.find(s => s.is_group_session);

  //get team members
  useEffect(() => {
    setBusinessData({ type: "SET_LOADING", data: true });
    getBusinessTeamMembers(businessID)
      .then(({ data: { data } }) => {
        const { business, team_members } = data;
        setBusinessData({
          type: "FETCH_BUSINESS",
          data: business,
        });
        setBusinessData({
          type: "FETCH_TEAM",
          data: team_members,
        });
      })
      .catch(() => {
        setBusinessData({ type: "SET_LOADING", data: false });
      });
  }, [businessID]);

  useEffect(() => {
    // businessData.businessData

    if (businessData.businessData?.priority_booking > 0) {
      //
      setSelectedBusiness({
        type: "UPDATE_USER_DETAILS",
        data: { create_account: true },
      });
    }
  }, [businessData.businessData]);

  useEffect(() => {
    resetServices();
    totalCost();
    if (selectedBusiness.staff?.identifier) {
      const ID = selectedBusiness.staff.identifier;
      getStaffServices(ID).then(
        ({
          data: {
            data: { services },
          },
        }) => {
          setBusinessData({
            type: "FETCH_SERVICES",
            data: services,
          });
        }
      );
    }
  }, [selectedBusiness.staff?.identifier]);

  useEffect(() => {
    (async () => {
      if (
        businessData?.businessData?.identifier &&
        selectedBusiness.date &&
        selectedBusiness.staff.identifier
      ) {
        //reset opening hours and selected time
        setBusinessData({
          type: "RESET_OPENING_HOURS",
        });
        setSelectedBusiness({
          type: "SELECT_HOUR",
          data: "",
        });
        //
        // Check if we have a group session service and get its quantity
        
        const quantity = groupService?.quantity || 1;

        const getOpeningHoursResponse = await getOpeningHours({
          business_id: businessData?.businessData?.identifier,
          body: {
            appointment_date: selectedBusiness.date,
            total_duration: selectedBusiness.services.reduce(
              (sum, service) => sum + service.duration,
              0
            ),
            team_member_id: !businessData.businessData.show_team_members
              ? 0
              : selectedBusiness.staff.id, // 0 so that i can manipulate it on back end,
            // Include quantity for group sessions
            ...(groupService && { quantity }),
            services: selectedBusiness.services.map(s => ({ id: s.id })),
          },
        });

        if (getOpeningHoursResponse?.data?.data) {
          const { opening_hours } = getOpeningHoursResponse?.data?.data;
          setBusinessData({
            type: "FETCH_OPENING_HOURS",
            data: opening_hours,
          });
        }
      }
    })();
  }, [selectedBusiness.date, groupService?.quantity ]);

  useEffect(() => {
    if (selectedBusiness.services) {
      try {
        localStorage.setItem(
          "Selected Services",
          JSON.stringify(selectedBusiness.services)
        );
      } catch (ee) {}
    }
  }, [selectedBusiness.services]);

  useEffect(() => {
    if (selectedBusiness.hour) {
      try {
        localStorage.setItem("booking time", selectedBusiness.hour);
      } catch (ee) {}
    }
  }, [selectedBusiness.hour]);

  useEffect(() => {
    if (selectedBusiness.date) {
      try {
        localStorage.setItem("booking date", selectedBusiness.date);
      } catch (ee) {}
    }
  }, [selectedBusiness.date]);

  const resetServices = () => {
    setBusinessData({
      type: "RESET_SERVICES",
    });
    setSelectedBusiness({
      type: "RESET_SERVICES",
    });
  };
  const totalCost = () => {
    setSelectedBusiness({
      type: "RESET_TOTAL_COST",
    });
  };

  return (
    <businessContext.Provider
      value={{
        businessData,
        selectedBusiness,
        setSelectedBusiness,
        // resetServices,
      }}
    >
      {children}
    </businessContext.Provider>
  );
}

function useBusinessContext() {
  return useContext(businessContext);
}

export { useBusinessContext };
